import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-550ead2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-cols-2" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref, reactive, inject } from "vue";
import "jodit/build/jodit.min.css";
import { JoditEditor } from "jodit-vue";
import UserService from "../../modules/users/services/UserService";
import type { FormInstance } from "element-plus";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendEmail',
  setup(__props, { expose: __expose }) {

const partyId = ref(0);
const dialogRef = ref(false);
const isLoading = ref(false);
const userInfos = inject<any>("userInfos");
const cc = ref("");
const bcc = ref("");
const formData = ref<any>({
  partyId: partyId.value,
  topicId: 10003,
  language: userInfos.value.language || "en",
  cc: [],
  bcc: [],
  title: "",
  subtitle: "",
  content: "",
});

const show = (_partyId) => {
  dialogRef.value = true;
  partyId.value = _partyId;
  formData.value.partyId = partyId.value;
};
const sendEmail = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  isLoading.value = true;
  try {
    formData.value.cc =
      cc.value.length !== 0
        ? cc.value.split(",").map((item) => item.trim())
        : [];
    formData.value.bcc =
      bcc.value.length !== 0
        ? bcc.value.split(",").map((item) => item.trim())
        : [];

    await UserService.sendEmailToUser(formData.value);
    dialogRef.value = false;
    formData.value.title = "";
    formData.value.content = "";
    notification.success();
  } catch (error) {
    console.error(error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  title: [
    { required: true, message: "This field is required", trigger: "change" },
  ],
  content: [
    { required: true, message: "This field is required", trigger: "change" },
  ],
});

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('action.sendEmail') + ' ' + partyId.value,
    width: "1500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: sendEmail,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.send")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, { label: "CC (Comma separated)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: cc.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cc).value = $event)),
                  disabled: isLoading.value,
                  class: "w-500px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "BCC (Comma separated)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: bcc.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bcc).value = $event)),
                  disabled: isLoading.value,
                  class: "w-500px"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.title'),
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.title,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.title) = $event)),
                disabled: isLoading.value,
                class: "w-500px"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.content'),
            prop: "content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(JoditEditor), {
                  modelValue: formData.value.content,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.content) = $event)),
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})